<template>
    <div class="bo-image-banner">
        <div
            v-for="banner in banners"
            :key="banner.index"
            :class="[
                'image-content',
                {
                    'is-single': banner.isSingle === true,
                    'grid' : banner.grid === true,
                },
            ]"
        >
            <img v-if="banner.image" :src="banner.image" />

            <div v-else-if="banner.title" class="text-block">
                <div class="title">{{ banner.title }}</div>
                <div class="subtitle">{{ banner.subtitle }}</div>
                <a class="btn-rounded" :href="banner.link" target="_blank">{{ banner.buttonText }}</a>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        banners: {
            type: Array,
            default: "",
        },
    },
};
</script>
